import React from 'react';
import { usePopper } from 'react-popper';

export const useComboboxPositioning = popperProps => {
  const referenceElementRef = React.useRef(null);
  const popperElementRef = React.useRef(null);
  const element = document.querySelector('.main');
  const popperValues = usePopper(referenceElementRef.current, popperElementRef.current, {
    placement: 'bottom',
    modifiers: [
      {
        name: 'flip',
        options: {
          fallbackPlacements: ['top'],
          boundary: element
        }
      },
      {
        name: 'offset',
        options: {
          offset: [0, 5]
        }
      }
    ],
    ...popperProps
  });
  return { referenceElementRef, popperElementRef, ...popperValues };
};
